import { Navigate, Route, Routes } from 'react-router-dom';
import { getToken } from '../api/client';
import BlogPostsIdare from './BlogPostsIdare';
import IdareLayout from './IdareLayout';
import PhotosIdare from './PhotosIdare';
import ProjectsIdare from './ProjectsIdare';

function IdareGuard() {
  if (!getToken()) {
    return <Navigate to="/idare/login" replace />;
  }

  return (
    <Routes>
      <Route element={<IdareLayout />}>
        <Route index element={<Navigate to="projects" replace />} />
        <Route path="projects" element={<ProjectsIdare />} />
        <Route path="blog-posts" element={<BlogPostsIdare />} />
        <Route path="photos" element={<PhotosIdare />} />
      </Route>
    </Routes>
  );
}

export default IdareGuard;
